/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { GetEquipmentQueryResponse, GetEquipmentPathParams, GetEquipment400, GetEquipment401, GetEquipment403, GetEquipment404, GetEquipment409, GetEquipment500 } from "../../types/equipmentController/GetEquipment.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getEquipment } from "../../client/equipmentController/getEquipment.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getEquipmentQueryKey = (organizationId: GetEquipmentPathParams["organizationId"] | undefined, equipmentId: GetEquipmentPathParams["equipmentId"] | undefined) => [{ url: '/api/organizations/:organizationId/equipment/:equipmentId', params: {organizationId:organizationId,equipmentId:equipmentId} }] as const

export type GetEquipmentQueryKey = ReturnType<typeof getEquipmentQueryKey>

export function getEquipmentQueryOptions(organizationId: GetEquipmentPathParams["organizationId"] | undefined, equipmentId: GetEquipmentPathParams["equipmentId"] | undefined, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getEquipmentQueryKey(organizationId, equipmentId)
        return queryOptions<GetEquipmentQueryResponse, ResponseErrorConfig<GetEquipment400 | GetEquipment401 | GetEquipment403 | GetEquipment404 | GetEquipment409 | GetEquipment500>, GetEquipmentQueryResponse, typeof queryKey>({
         enabled: !!(organizationId && equipmentId),
         queryKey,
         queryFn: async ({ signal }) => {
            return getEquipment(organizationId!, equipmentId!, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get equipment detail
 * {@link /api/organizations/:organizationId/equipment/:equipmentId}
 */
export function useGetEquipment<TData = GetEquipmentQueryResponse, TQueryData = GetEquipmentQueryResponse, TQueryKey extends QueryKey = GetEquipmentQueryKey>(organizationId: GetEquipmentPathParams["organizationId"] | undefined, equipmentId: GetEquipmentPathParams["equipmentId"] | undefined, options: 
{
  query?: Partial<QueryObserverOptions<GetEquipmentQueryResponse, ResponseErrorConfig<GetEquipment400 | GetEquipment401 | GetEquipment403 | GetEquipment404 | GetEquipment409 | GetEquipment500>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? getEquipmentQueryKey(organizationId, equipmentId)
         

         const query = useQuery({
          ...getEquipmentQueryOptions(organizationId, equipmentId, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetEquipment400 | GetEquipment401 | GetEquipment403 | GetEquipment404 | GetEquipment409 | GetEquipment500>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}